export default __webpack_public_path__ + "f0e768d15b40ab5494edb6b4f18362d8.png";